/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable max-len */
export const deploymentGuideMessages = {
    'deploymentGuide.management.BusinessOwner.name':
        'Assign Responsibility and Business Owners',

    'deploymentGuide.optimization.AutomatedReports.name':
        'Run and Schedule Automated Reports',
    'deploymentGuide.optimization.OffboardWorkflow.name':
        'Run an Offboard Report',
    'deploymentGuide.optimization.setupAlerts.name': 'Setup Alerts',
    'deploymentGuide.optimization.reviewVendorIncidents.name':
        'Review Vendor Incident',
    'deploymentGuide.optimization.createCustomTags.name': 'Create Custom Tags',
    'deploymentGuide.optimization.onboardEmployee.name': 'Onboard an Employee',

    'onboarding.skip': 'Skip onboarding',
    'onboarding.agent': 'Deploy SaaS Discovery Agent',
    'onboarding.identityManagement': 'Set up Identity Management Integration',
    'onboarding.SaasOps': 'Configure SaaS Ops Integration'
};
